import { isAuthorized } from 'utils/Auth'
import { createReducer } from '../../utils'

export const PORTFOLIO_BY_ID_REQUEST = 'sherrinford/product/portfolio/PORTFOLIO_BY_ID_REQUEST'
export const PORTFOLIO_BY_ID_SUCCESS = 'sherrinford/product/portfolio/PORTFOLIO_BY_ID_SUCCESS'
export const PORTFOLIO_BY_ID_ERROR = 'sherrinford/product/portfolio/PORTFOLIO_BY_ID_ERROR'

export const PORTFOLIO_REQUEST = 'sherrinford/product/portfolio/PORTFOLIO_REQUEST'
export const PORTFOLIO_SUCCESS = 'sherrinford/product/portfolio/PORTFOLIO_SUCCESS'
export const PORTFOLIO_ERROR = 'sherrinford/product/portfolio/PORTFOLIO_ERROR'

export const UPDATE_PORTFOLIO_STATUS_REQUEST = 'sherrinford/product/detail/UPDATE_PORTFOLIO_STATUS_REQUEST'
export const UPDATE_PORTFOLIO_STATUS_SUCCESS = 'sherrinford/product/detail/UPDATE_PORTFOLIO_STATUS_SUCCESS'
export const UPDATE_PORTFOLIO_STATUS_ERROR = 'sherrinford/product/detail/UPDATE_PORTFOLIO_STATUS_ERROR'

export const POST_REJECT_REASON_REQUEST = 'sherrinford/product/portfolio/POST_REJECT_REASON_REQUEST'
export const POST_REJECT_REASON_SUCCESS = 'sherrinford/product/portfolio/POST_REJECT_REASON_SUCCESS'
export const POST_REJECT_REASON_ERROR = 'sherrinford/product/portfolio/POST_REJECT_REASON_ERROR'

export const IS_LOADING = 'sherrinford/product/portfolio/IS_LOADING'
export const DATA = 'sherrinford/product/portfolio/DATA'
export const ACTION = 'sherrinford/product/portfolio/ACTION'
export const ACTION_CLEAN = 'sherrinford/product/portfolio/ACTION_CLEAN'
export const SET_NUM_PAGES = 'sherrinford/product/portfolio/SET_NUM_PAGES'

const initialState = {
  data: {
    id: '',
    title: '',
    filetype: '',
    status: 0,
    url: '',
    urlRawFile: '',
  },
  selected: {
    status: 0,
    rejectReason: '',
  },
  status: [{
    label: 'Need Review',
  }, {
    label: 'Approved',
  }, {
    label: 'Rejected',
  }],
  isLoading: false,
  isError: false,
  errorMessage: '',
  textNumPages: 0,
}

export default createReducer(initialState, {
  [PORTFOLIO_REQUEST]: state => ({
    ...state,
    isLoading: true,
  }),
  [PORTFOLIO_SUCCESS]: state => ({
    ...state,
    isLoading: false,
  }),
  [PORTFOLIO_ERROR]: state => ({
    ...state,
    isLoading: false,
  }),
  [PORTFOLIO_BY_ID_REQUEST]: state => ({
    ...state,
    isLoading: true,
  }),
  [PORTFOLIO_BY_ID_SUCCESS]: (state, data) => ({
    ...state,
    data,
    isLoading: false,
  }),
  [PORTFOLIO_BY_ID_ERROR]: (state, data) => ({
    ...state,
    isError: true,
    errorMessage: data.message,
    isLoading: false,
  }),
  [UPDATE_PORTFOLIO_STATUS_REQUEST]: state => ({
    ...state,
    isLoading: true,
  }),
  [UPDATE_PORTFOLIO_STATUS_SUCCESS]: state => ({
    ...state,
    isLoading: false,
  }),
  [UPDATE_PORTFOLIO_STATUS_ERROR]: (state, data) => ({
    ...state,
    isError: true,
    errorMessage: data.message,
    isLoading: false,
  }),
  [POST_REJECT_REASON_REQUEST]: state => ({
    ...state,
    isLoading: true,
  }),
  [POST_REJECT_REASON_SUCCESS]: state => ({
    ...state,
    isLoading: false,
  }),
  [POST_REJECT_REASON_ERROR]: (state, data) => ({
    ...state,
    isError: true,
    errorMessage: data.message,
    isLoading: false,
  }),

  [IS_LOADING]: (state, data) => ({
    ...state,
    isLoading: data,
  }),

  [DATA]: (state, data) => ({
    ...state,
    data,
  }),
  [ACTION]: (state, data) => ({
    ...state,
    selected: {
      ...state.selected,
      [data.field]: data.value,
    },
  }),
  [ACTION_CLEAN]: state => ({
    ...state,
    selected: initialState.selected,
  }),

  [SET_NUM_PAGES]: (state, data) => ({
    ...state,
    textNumPages: data,
  }),
})

export const getPortfolios = (productId, qs, cb = () => {}) => {
  const token = JSON.parse(isAuthorized())
  return {
    type: [
      PORTFOLIO_REQUEST,
      PORTFOLIO_SUCCESS,
      PORTFOLIO_ERROR,
    ],
    shuttle: {
      method: 'GET',
      path: `/product/${productId}/portfolio`,
      authorization: `${token}`,
      payloads: qs,
    },
    nextAction: res => cb(res),
  }
}

export const getPortfolioById = (id, cb = () => {}) => {
  const token = JSON.parse(isAuthorized())
  return {
    type: [
      PORTFOLIO_BY_ID_REQUEST,
      PORTFOLIO_BY_ID_SUCCESS,
      PORTFOLIO_BY_ID_ERROR,
    ],
    shuttle: {
      method: 'GET',
      path: `/portfolio/${id}`,
      authorization: `${token}`,
    },
    nextAction: res => cb(res),
  }
}

export const putPortfolioStatus = (id, portfolio, cb = () => {}) => {
  const token = JSON.parse(isAuthorized())
  return {
    type: [
      UPDATE_PORTFOLIO_STATUS_REQUEST,
      UPDATE_PORTFOLIO_STATUS_SUCCESS,
      UPDATE_PORTFOLIO_STATUS_ERROR,
    ],
    shuttle: {
      method: 'PUT',
      path: `/portfolio/${id}/status`,
      authorization: token,
      payloads: portfolio,
    },
    nextAction: res => cb(res),
  }
}

export const postRejectReason = (rejectReason, cb = () => {}) => {
  const token = JSON.parse(isAuthorized())
  return {
    type: [
      POST_REJECT_REASON_REQUEST,
      POST_REJECT_REASON_SUCCESS,
      POST_REJECT_REASON_ERROR,
    ],
    shuttle: {
      method: 'POST',
      path: '/portfolio_reject_reason',
      authorization: token,
      payloads: rejectReason,
    },
    nextAction: res => cb(res),
  }
}

export const setPortfolioAction = data => ({
  type: [ACTION],
  payload: data,
})

export const setData = data => ({
  type: [DATA],
  payload: data,
})

export const setLoadState = data => ({
  type: [IS_LOADING],
  payload: data,
})

export const setSelectedClean = () => ({
  type: [ACTION_CLEAN],
})

export const setNumPagesTotal = data => ({
  type: [SET_NUM_PAGES],
  payload: data,
})
